import { useEffect, useRef, useState } from "react";
import { Bar, Pie } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import moment from "moment";
import { Icon } from "@iconify/react";
import { Autocomplete, TextField } from "@mui/material";
import "./DashboardOutbound.css";
import Loader from "../Components/Loader";
import formatSecondsToDuration from "../Helper/formatSecondsToDuration";

import {
  getAllAssignment,
  getAssignmentCalled,
  getCampaignAgent,
  getDashboardAgentStateByTL,
  getDashboardBindCall,
  getDashboardStatusCall,
  getTeamLeader,
  getTodayAssignment,
} from "../Store/Actions/DashboardAction";

const DashboardOutbound = () => {
  const [agentData, setAgentData] = useState([]);
  const [agentList, setAgentList] = useState([]);
  const [assignmentCalled, setAssignmentCalled] = useState(0);
  const [allAssignment, setAllAssignment] = useState(0);
  const [callData, setCallData] = useState(null);
  const [campaignList, setCampaignList] = useState([]);
  const [hourlyData, setHourlyData] = useState([]);

  const initialDisplayValues = {
    campaign: [],
    agent: [],
  };

  const [displayValues, setDisplayValues] = useState(initialDisplayValues);

  const initialParams = {
    campaignID: "",
    filterAgent: "",
  };

  const [filterParams, setFilterParams] = useState(initialParams);
  const [isFiltering, setIsFiltering] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [statusCallData, setStatusCallData] = useState([]);
  const [todayAssignment, setTodayAssignment] = useState(0);

  // Ref to always hold the latest filterParams
  const filterParamsRef = useRef(filterParams);

  const currencyFormatter = new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    minimumFractionDigits: 0, // no decimal places for Rupiah
  });

  const fetchData = () => {
    const currentParams = filterParamsRef.current;

    getDashboardBindCall({
      campaignID: currentParams.campaignID,
      filterAgent: currentParams.filterAgent,
    })
      .then((response) => {
        if (response.status) {
          setCallData(response.data.summary[0]);
          setHourlyData(response.data.hourly);
          setIsFiltering(false);
        } else {
          console.log("error", response.error);
          setIsFiltering(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
        setIsFiltering(false);
      });

    getTodayAssignment({
      campaignID: currentParams.campaignID,
    })
      .then((response) => {
        if (response.status) {
          setTodayAssignment(response.data);
          setIsFiltering(false);
        } else {
          console.log("error", response.error);
          setIsFiltering(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
        setIsFiltering(false);
      });

    getAssignmentCalled({
      campaignID: currentParams.campaignID,
    })
      .then((response) => {
        if (response.status) {
          setAssignmentCalled(response.data);
          setIsFiltering(false);
        } else {
          console.log("error", response.error);
          setIsFiltering(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
        setIsFiltering(false);
      });

    getAllAssignment({
      campaignID: currentParams.campaignID,
    })
      .then((response) => {
        if (response.status) {
          setAllAssignment(response.data);
          setIsFiltering(false);
        } else {
          console.log("error", response.error);
          setIsFiltering(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
        setIsFiltering(false);
      });

    getDashboardAgentStateByTL(currentParams.campaignID)
      .then((response) => {
        if (response.status) {
          setAgentData(response.data);
          setIsFiltering(false);
        } else {
          console.log("error", response.error);
          setIsFiltering(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
        setIsFiltering(false);
      });

    getDashboardStatusCall(currentParams.campaignID)
      .then((response) => {
        if (response.status) {
          setStatusCallData(response.data);
          setIsFiltering(false);
        } else {
          console.log("error", response.error);
          setIsFiltering(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
        setIsFiltering(false);
      });
  };

  // Keep ref updated when filterParams changes
  useEffect(() => {
    filterParamsRef.current = filterParams;
  }, [filterParams]);

  useEffect(() => {
    // Fetch data on first render
    fetchData();

    // Fetch data every one second
    const interval = setInterval(() => {
      fetchData();
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    getCampaignAgent()
      .then((response) => {
        if (response.status) {
          setCampaignList(response.data);
          setIsLoading(false);
        } else {
          console.log("error", response.error);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
        setIsLoading(false);
      });

    getTeamLeader()
      .then((response) => {
        if (response.status) {
          setAgentList(response.data);
          setIsLoading(false);
        } else {
          console.log("error", response.error);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
        setIsLoading(false);
      });
  }, []);

  const labels = agentData?.map((agent) => agent.agentcode);

  const dataAgentStatus = {
    labels,

    datasets: [
      {
        label: "READY",

        data: labels?.map((label) => {
          let currentAgent = agentData?.find(
            (agent) => agent.agentcode === label
          );

          return currentAgent.ready;
        }),

        backgroundColor: "#00FF00",
      },

      {
        label: "BUSY",

        data: labels?.map((label) => {
          let currentAgent = agentData?.find(
            (agent) => agent.agentcode === label
          );

          return currentAgent.busy;
        }),

        backgroundColor: "#FF0000",
      },

      {
        label: "ACW",

        data: labels?.map((label) => {
          let currentAgent = agentData?.find(
            (agent) => agent.agentcode === label
          );

          return currentAgent.acw;
        }),

        backgroundColor: "#FFE900",
      },

      {
        label: "AUX",

        data: labels?.map((label) => {
          let currentAgent = agentData?.find(
            (agent) => agent.agentcode === label
          );

          return currentAgent.aux;
        }),

        backgroundColor: "#EE7314",
      },
    ],
  };

  const optionsAgentStatus = {
    indexAxis: "y",
    maintainAspectRatio: false,

    plugins: {
      datalabels: {
        anchor: "end",
        align: "end",

        font: {
          size: 14,
          weight: 700,
        },

        color: "#393939",
        display: (context) => context.dataset.data[context.dataIndex] > 0,
      },

      legend: { position: "bottom" },

      title: {
        color: "#000",
        display: true,

        font: {
          size: 18,
          weight: 500,
        },

        text: `Agent Status Per TL ${moment().format("DD MMM YYYY")}`,
      },
    },

    responsive: true,

    scales: {
      x: {
        grace: "20%",
      },
    },
  };

  const optionsHourly = {
    maintainAspectRatio: false,
    responsive: true,

    plugins: {
      legend: { position: "top" },

      title: {
        color: "#000",
        display: true,

        font: {
          size: 18,
          weight: 500,
        },

        text: `Activity Call - ${moment().format("DD MMM YYYY")}`,
      },
    },

    scales: {
      y: {
        grace: "10%",
      },
    },
  };

  const labelsHourly = hourlyData?.map((data) => data.hour) || [];

  const dataHourly = {
    labels: labelsHourly,

    datasets: [
      {
        label: "Total Attempts",

        data: labelsHourly.map((label) => {
          let data = hourlyData?.find((data) => data.hour === label);
          return data ? data.totalattempt : 0;
        }),

        backgroundColor: "#C886D3",
      },

      {
        label: "Total Dial",

        data: labelsHourly.map((label) => {
          let data = hourlyData?.find((data) => data.hour === label);
          return data ? data.totaldial : 0;
        }),

        backgroundColor: "#2f53f5",
      },

      {
        label: "Contacted",

        data: labelsHourly.map((label) => {
          let data = hourlyData?.find((data) => data.hour === label);
          return data ? data.answeredcall : 0;
        }),

        backgroundColor: "#4CAF50",
      },

      {
        label: "Not Contacted",

        data: labelsHourly.map((label) => {
          let data = hourlyData?.find((data) => data.hour === label);
          return data ? data.noansweredcall : 0;
        }),

        backgroundColor: "#c05d24",
      },

      {
        label: "Abandoned",

        data: labelsHourly.map((label) => {
          let data = hourlyData?.find((data) => data.hour === label);
          return data ? data.totalabandon : 0;
        }),

        backgroundColor: "#c02424",
      },
    ],
  };

  const optionsStatusCall = {
    maintainAspectRatio: false,
    responsive: true,

    plugins: {
      datalabels: {
        anchor: "end",
        align: "start",

        font: {
          size: 14,
          weight: 700,
        },

        color: "#393939",
        display: (context) => context.dataset.data[context.dataIndex] > 0,
      },

      legend: { position: "bottom" },

      title: {
        color: "#000",
        display: true,

        font: {
          size: 18,
          weight: 500,
        },

        text: "Status Call",
      },
    },
  };

  const dataStatusCall = {
    labels: statusCallData?.map((status) => status.name),

    datasets: [
      {
        data: statusCallData?.map((status) => status.value),

        backgroundColor: [
          "#00FF00",
          "#FF0000",
          "#FFE900",
          "#EE7314",
          "#00e1ff",
          "#f064e9",
          "#e68f0d",
          "#27cfb3",
          "#91d7ff",
          "#75da3b",
          "#ff3ab3",
          "#a626f0",
        ],
      },
    ],
  };

  function handleSubmit(e) {
    e.preventDefault();
    setIsFiltering(true);
    fetchData();
  }

  return (
    <div className="dashboard-outbound">
      <div className="list_header">
        <div className="list_headerLeft">
          <h1>Outbound</h1>
        </div>
      </div>

      <div className="containerDashboard">
        {isLoading ? (
          <Loader />
        ) : (
          <>
            <section className="filters">
              <form
                method="post"
                onSubmit={handleSubmit}
              >
                <div className="form-inputs">
                  <div className="filter-item">
                    <Autocomplete
                      filterSelectedOptions
                      multiple
                      options={campaignList}
                      value={displayValues.campaign}
                      getOptionLabel={(campaign) => campaign.campaignname}
                      onChange={(event, value) => {
                        setFilterParams({
                          ...filterParams,
                          campaignID: value?.length
                            ? value.map((val) => val.campaignid)
                            : "",
                        });

                        setDisplayValues({
                          ...displayValues,
                          campaign: value,
                        });
                      }}
                      renderInput={(params) => (
                        <TextField {...params} label="Campaign" />
                      )}
                    />
                  </div>

                  <div className="filter-item">
                    <Autocomplete
                      filterSelectedOptions
                      multiple
                      options={agentList}
                      value={displayValues.agent}
                      getOptionLabel={(agent) => agent.agentcode}
                      onChange={(event, value) => {
                        setFilterParams({
                          ...filterParams,
                          filterAgent: value?.length
                            ? value.map((val) => val.agentid)
                            : "",
                        });

                        setDisplayValues({
                          ...displayValues,
                          agent: value,
                        });
                      }}
                      renderInput={(params) => (
                        <TextField {...params} label="TL" />
                      )}
                    />
                  </div>

                  <button
                    className="filter-item filter-button"
                    disabled={isFiltering}
                    type="submit"
                  >
                    <Icon height="20" icon="fluent:script-20-filled" />
                    Filter
                  </button>
                </div>
              </form>
            </section>

            <section className="cards">
              <div className="item call-initiated">
                <Icon
                  className="icon"
                  height="40"
                  icon="ic:baseline-phone"
                  width="40"
                />

                <div>
                  <p className="title">Total Attempts</p>
                  <p className="value">{callData?.totalattempt}</p>
                </div>
              </div>

              <div className="item contacted">
                <Icon
                  className="icon"
                  height="40"
                  icon="uil:smile"
                  width="40"
                />

                <div>
                  <p className="title">Contacted</p>
                  <p className="value">{callData?.answeredcall}</p>
                </div>
              </div>

              <div className="item uncontacted">
                <Icon className="icon" height="40" icon="uil:meh" width="40" />

                <div>
                  <p className="title">Answering Machine</p>
                  <p className="value">{callData?.noansweredcall}</p>
                </div>
              </div>

              <div className="item agree">
                <Icon className="icon" height="40" icon="uil:lock" width="40" />

                <div>
                  <p className="title">Total PTP Today</p>
                  <p className="value">{callData?.totalptp}</p>
                </div>
              </div>

              <div className="item total-assignment">
                <Icon
                  className="icon"
                  height="40"
                  icon="uil:smile"
                  width="40"
                />

                <div>
                  <p className="title">Total Assignment</p>
                  <p className="value">{todayAssignment}</p>
                </div>
              </div>

              <div className="item called-today">
                <Icon className="icon" height="40" icon="uil:meh" width="40" />

                <div>
                  <p className="title">Assignment Called Today</p>
                  <p className="value">{assignmentCalled}</p>
                </div>
              </div>

              <div className="item total-all">
                <Icon className="icon" height="40" icon="uil:lock" width="40" />

                <div>
                  <p className="title">Total All Assignment Called</p>
                  <p className="value">{allAssignment}</p>
                </div>
              </div>
            </section>

            <section className="agents">
              <section className="item agent-status-chart">
                <Bar
                  className="table"
                  options={optionsAgentStatus}
                  data={dataAgentStatus}
                  plugins={[ChartDataLabels]}
                />
              </section>

              <section className="item status-call-chart">
                <div>
                  {statusCallData?.length > 0 ? (
                    <Pie
                      data={dataStatusCall}
                      options={optionsStatusCall}
                      plugins={[ChartDataLabels]}
                    />
                  ) : (
                    <p className="no-data">No Status Call Data Available</p>
                  )}
                </div>
              </section>

              <section className="agent-cards">
                <div className="agent-card top-card">
                  <p className="label">Total PTP Amount</p>

                  <p className="value">
                    {currencyFormatter.format(callData?.totalptpamount)}
                  </p>
                </div>

                <div className="agent-card top-card">
                  <p className="label">Total Call Untouched Today</p>
                  <p className="value">{callData?.shouldbecalledtoday ?? 0}</p>
                </div>

                <div className="agent-card middle-card">
                  <p className="label">Total PAID Amount</p>

                  <p className="value">
                    {currencyFormatter.format(callData?.totalpaidamount)}
                  </p>
                </div>

                <div className="agent-card middle-card">
                  <p className="label">Total Talk Duration</p>

                  <p className="value">
                    {formatSecondsToDuration(callData?.averagetalktime)}
                  </p>
                </div>

                <div className="agent-card bottom-card">
                  <p className="label">Total PAID OFF Amount</p>

                  <p className="value">
                    {currencyFormatter.format(callData?.totalpaidoffamount)}
                  </p>
                </div>

                <div className="agent-card bottom-card broken-ptp">
                  <p className="label">Total Broken PTP Amount</p>

                  <p className="value">
                    {currencyFormatter.format(callData?.totalbrokenptpamount)}
                  </p>
                </div>
              </section>
            </section>

            <section className="item hourly-chart">
              <Bar
                className="table"
                options={optionsHourly}
                data={dataHourly}
              />
            </section>
          </>
        )}
      </div>
    </div>
  );
};

export default DashboardOutbound;
